// extracted by mini-css-extract-plugin
export default {"paper":"Nonce_paper__N5Vb6","navItem":"Nonce_navItem__oB9mW","activeNavItem":"Nonce_activeNavItem__nLh-5"};